import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import { useAccount } from 'wagmi';
import { useAtomValue } from 'jotai';
import { Storage } from '~/core/storages';
import { blinkoAutoReferralCodeStorage } from '~/core/storages';
import { api } from '~/blinko/api';
import { useReferrer } from '~/blinko/hooks/useReferral';
import { atomWalletModal } from '~/blinko/modals/wallet.modal';

export const ReferralHandler = ({ storage }: { storage: Storage }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [referralCode, setReferralCode] = useState<string | null>(null)
  const [autoReferralCode, setAutoReferralCode] = useState<string | null>(null)
  const { address } = useAccount();
  const isSigned = useAtomValue(atomWalletModal.isSigned);
  const { mutate: mutateReferrer } = useReferrer();

  // Read params from URL
  useEffect(() => {
    const r = searchParams.get('r')
    const ref = searchParams.get('ref')

    if (r) {
      setAutoReferralCode(r)
      blinkoAutoReferralCodeStorage.set(r)
    } else if (ref) {
      setReferralCode(ref)
      storage.set(ref)
    }
  }, [searchParams]);

  // Clean URL params
  useEffect(() => {
    if (autoReferralCode || referralCode) {
      setSearchParams(prev => {
        prev.delete('r');
        prev.delete('ref');
        return prev;
      }, { replace: true });
    }
  }, [autoReferralCode, referralCode, setSearchParams])

  // Apply auto referral code after sign-in is complete
  useEffect(() => {
    const pendingCode = blinkoAutoReferralCodeStorage.get()
    if (!address || !isSigned || !pendingCode) return

    api.applyReferralCode(address, pendingCode)
      .then(() => {
        blinkoAutoReferralCodeStorage.remove()
        mutateReferrer()
      })
      .catch(() => {
        blinkoAutoReferralCodeStorage.remove()
      })
  }, [address, isSigned, autoReferralCode])

  return <></>
}
